import staticConfig from './config.static';
import environmentConfig from './config.environment';

const config = Object.assign(staticConfig, environmentConfig);

export default config;
